import { useSyncExternalStore, useCallback } from 'react';

const EMPTY_UNSUBSCRIBE = () => {};

/**
 * CSS 미디어 쿼리를 구독하는 훅.
 * 기존 MainLayout 의 `window.innerWidth` 1회성 판정을 대체한다.
 * (리사이즈 / 화면 회전 시에도 정확히 갱신됨)
 *
 * useSyncExternalStore 를 쓰므로 외부 값과 렌더 결과가 어긋나지 않고,
 * 초기 동기화를 위한 추가 렌더도 발생하지 않는다.
 */
export const useMediaQuery = (query) => {
  const subscribe = useCallback((onStoreChange) => {
    if (typeof window === 'undefined' || !window.matchMedia) return EMPTY_UNSUBSCRIBE;
    const mql = window.matchMedia(query);
    mql.addEventListener('change', onStoreChange);
    return () => mql.removeEventListener('change', onStoreChange);
  }, [query]);

  const getSnapshot = useCallback(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  }, [query]);

  // 서버 렌더링 시에는 항상 false (모바일 우선)
  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};

/** Tailwind 의 lg 브레이크포인트(1024px)와 동일 기준 */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');

export default useMediaQuery;
